import styled from "styled-components";
import { Text1, Text2, Text3 } from "../../Common";

export const MainWrapper = styled.div`
    display: flex;
    ${props=> props.backgroundUrl && `background-image: url(${props.backgroundUrl})`};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;   
`
export const Heading = styled(Text1)`
  background: linear-gradient(
    90deg,
    #06d9ca 17.68%,
    #19b6f0 39.18%,
    #6e6cff 50%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media screen and (max-width:768px){
    font-size : 1.4rem;
  }
`;